import {useEffect, useState} from "react";
import {apiGet} from "../utils";
import {AppBar, Typography, useTheme} from "@mui/material";
import Grid from "@mui/material/Grid2";

export const AppFooter = () => {
    const theme = useTheme();
    const dims = theme.dimensions;
    const [uiVersion, setUiVersion] = useState(null);
    const [apiVersion, setApiVersion] = useState(null);

    const fetchApiVersion = () => {
        setUiVersion(`${process.env.REACT_APP_UI_VERSION} (${process.env.REACT_APP_GIT_COMMIT_ID})`);
        apiGet(`version`, (data) => {
            setApiVersion(data.version);
        });
    };

    useEffect(() => {
        fetchApiVersion();
    }, []);

    return (
        <div style={{position: 'fixed', bottom: 0, left: 0, width: '100%', zIndex: 100}}>
            <AppBar position="sticky" style={{height: dims.footerHeight}}>
                <Grid container justifyContent="center">
                    <Typography>UI version: {uiVersion} - API version: {apiVersion}</Typography>
                </Grid>
            </AppBar>
        </div>
    );
};